import { RefreshCw } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";
import { useApp } from "@/context/AppContext";

export const ProductGridSkeleton = ({ count = 8 }) => (
  <div
    className="grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-12 md:gap-x-6 md:gap-y-16"
    data-testid="products-loading"
    aria-busy="true"
  >
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="space-y-3">
        <Skeleton className="aspect-[3/4] w-full rounded-none" />
        <Skeleton className="h-3 w-1/3" />
        <Skeleton className="h-4 w-2/3" />
        <Skeleton className="h-3 w-1/4" />
      </div>
    ))}
  </div>
);

export const ProductsError = ({ onRetry }) => {
  const { t } = useApp();
  return (
    <div
      className="border border-line py-16 flex flex-col items-center justify-center gap-5 text-center"
      data-testid="products-error"
      role="alert"
    >
      <p className="text-ink/70 font-light">{t.shop.loadError}</p>
      <button
        onClick={onRetry}
        data-testid="products-retry"
        className="inline-flex items-center gap-2 border border-ink px-6 py-3 text-xs uppercase tracking-[0.2em] transition-colors duration-500 hover:bg-ink hover:text-paper"
      >
        <RefreshCw className="h-4 w-4" /> {t.shop.retry}
      </button>
    </div>
  );
};
